import React from 'react'
import RoleWiseLogs from '../Logs/RoleWiseLogs'

const AdminLogs = () => {
    return(
        <RoleWiseLogs role="admin" title="Admin"></RoleWiseLogs>
    )
}

export default AdminLogs